<script setup>
import { useIdle } from '@vueuse/core';
import { callAPI, DRUPAL_API_ROUTE } from '@/service/DrupalService';
import { ref, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { locale } = useI18n();

const { idle } = useIdle(30 * 60 * 1000);

const homepage = import.meta.env.VITE_DRUPAL_URL;
const timeout = import.meta.env.VITE_TIMEOUT;
const isAuthenticated = ref(true);
const authAlertVisible = ref(false);

const handleLogout = async () => {
  var request = await callAPI(DRUPAL_API_ROUTE.LOGOUT_TOKEN);

  if (request.status == 200) {
    var logoutToken = request.data;
    var request = await callAPI(DRUPAL_API_ROUTE.LOGOUT, { logout_token: logoutToken });
    localStorage.clear();
  }
}

function handleRedirect() {
  authAlertVisible.value = false;
  window.location.href = homepage + '/' + locale.value + '/user/login';
}


watch(idle, (idleValue) => {
  if (idleValue && timeout == 'true') {
    handleLogout();
    isAuthenticated.value = false;
    authAlertVisible.value = true;
  }
})

</script>

<template>
  <div v-if="!isAuthenticated">
    <Dialog v-model:visible="authAlertVisible" modal :header="t('auth_watcher.title')" :style="{ width: '25rem' }">
      <span class="text-surface-500 dark:text-surface-400 block mb-8">{{ t('auth_watcher.subtitle') }}</span>
      <div class="flex justify-end gap-2">
        <Button type="button" :label="t('auth_watcher.login')" @click=handleRedirect></Button>
      </div>
    </Dialog>
  </div>
</template>
